export default __webpack_public_path__ + "static/media/Esmax-20-Tab-eng.ae4956ff.jpg";